import type React from 'react'
import {Heading, Link} from '@primer/react'
import {provideFeedback} from '../../hooks/use-search-bar-events'
import styles from './Feedback.module.css'

export default function Feedback() {
  return (
    <div className={styles.container}>
      <Heading as="h2" className={styles.heading}>
        How can we improve search?
      </Heading>{' '}
      <Link
        className={styles.feedbackLink}
        as="button"
        onClick={(e: React.MouseEvent) => {
          provideFeedback()
          e.preventDefault()

          // NOTE: This is necessary to prevent the dialog from instantly closing
          e.stopPropagation()
        }}
      >
        <span className={styles.feedbackText}>Give feedback</span>
      </Link>
    </div>
  )
}
